/**
 * Helpers shared by the page files. Today only `getHeaderData`, used by every page that renders
 * `HeaderLayout.tsx`.
 */
import { HeaderPageProps } from "@ryerson/frontend.contentful";

// To destructure header, location, footer data from props object that is supplied to all pages
/**
 * Picks the three Contentful props that `HeaderLayout` needs out of a page's props, which
 * `allContentfulHeaderCalls()` put there in `getStaticProps`. Used as
 * `<HeaderLayout {...getHeaderData(props)}>`, so page-specific props aren't spread onto the layout.
 */
export function getHeaderData(props: HeaderPageProps) {
	const { ryersonHeaderData, ryersonLocationData, ryersonFooterData } = props;
	return {
		ryersonHeaderData,
		ryersonLocationData,
		ryersonFooterData,
	};
}
